module.exports = __webpack_public_path__ + "img/platform2.a95343c6.png";